/* Vishal Custom.js code */
/*document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[action="/search"]').forEach(form => {
    form.addEventListener('submit', function(e) {
      const input = this.querySelector('input[name="q"]');
      if (input && input.value.trim().length === 2) {
        // Appends a wildcard to force a prefix search on short terms
        input.value = input.value.trim() + '*';
      }
    });
  });
});*/
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[action="/search"]').forEach(form => {
    form.addEventListener('submit', function(e) {
      const originalInput = this.querySelector('input[name="q"]');
      
      if (originalInput && originalInput.value.trim().length === 2) {
        // 1. Create a hidden input field to pass the backend parameter
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'q';
        hiddenInput.value = originalInput.value.trim() + '*';
        
        // 2. Disable the name attribute on the visible box so it isn't submitted
        originalInput.removeAttribute('name');
        
        // 3. Append our clean, hidden wildcard value to the form execution
        this.appendChild(hiddenInput);
      }
    });
  });
});

